import { Button, Space, Tooltip, Typography } from "antd";
import { useEffect, useState } from "react";

import SpaceWrapper from "../../components/widgets/space-wrapper/SpaceWrapper";
import { useCustomToolStore } from "../../store/custom-tool-store";
import { ManageDocsModal } from "./ManageDocsModal";
import { IndexStatusIcon } from "./IndexStatusIcon";
import { UploadIcon } from "../assets";
import { indexStatuses } from "./helper";
import { indexDocument } from "./simple-prompt-studio-api-service";
import { useAlertStore } from "../../store/alert-store";
import { useExceptionHandler } from "../../hooks/useExceptionHandler";
import { UPLOAD } from "./constants";

function ListOfDocuments() {
  const [openManageDocs, setOpenManageDocs] = useState(false);
  const [docIndexStatus, setDocIndexStatus] = useState({});
  const { details, listOfDocs, selectedDoc, updateCustomTool, refreshRawView } =
    useCustomToolStore();
  const { setAlertDetails } = useAlertStore();
  const handleException = useExceptionHandler();

  useEffect(() => {
    if (!listOfDocs?.length) {
      return;
    }

    const doc = listOfDocs[0];
    updateCustomTool({ selectedDoc: doc });

    indexDocuments();
  }, []);

  useEffect(() => {
    const cusToolState = {};
    if (docIndexStatus[selectedDoc?.document_id] === indexStatuses.success) {
      cusToolState["refreshRawView"] = !refreshRawView;
    }

    const updatedListOfDocs = [...listOfDocs].map((doc) => {
      if (!docIndexStatus[doc?.document_id]) {
        return doc;
      }

      doc["index_status"] = docIndexStatus[doc?.document_id];
      return doc;
    });

    cusToolState["listOfDocs"] = updatedListOfDocs;
    updateCustomTool(cusToolState);
  }, [docIndexStatus]);

  const handleDocAdd = (doc) => {
    updateIndexStatus(doc?.document_id, indexStatuses.yet_to_start);
    indexDocumentRequest(
      doc?.document_id,
      doc?.document_name,
      details?.tool_id
    );
  };

  const indexDocuments = () => {
    [...(listOfDocs || [])].forEach((doc) => {
      if (doc?.index_status === indexStatuses.success) return;
      indexDocumentRequest(
        doc?.document_id,
        doc?.document_name,
        details?.tool_id
      );
    });
  };

  const indexDocumentRequest = (docId, docName, toolId) => {
    const body = {
      document_id: docId,
      sps_id: toolId,
    };

    updateIndexStatus(docId, indexStatuses.in_progress);
    indexDocument(body)
      .then(() => {
        updateIndexStatus(docId, indexStatuses.success);
      })
      .catch((err) => {
        updateIndexStatus(docId, indexStatuses.failed);
        setAlertDetails(
          handleException(err, `Failed to index document: ${docName}`)
        );
      });
  };

  const updateIndexStatus = (docId, status) => {
    setDocIndexStatus((prev) => {
      const obj = {
        [docId]: status,
      };
      return { ...prev, ...obj };
    });
  };

  const onSelectedDocChange = (doc) => {
    updateCustomTool({ selectedDoc: doc });
  };

  return (
    <>
      <div className="sps-list-of-docs layout">
        <Space direction="vertical" size={60} className="width-100">
          <Space direction="vertical" className="width-100">
            <div>
              <Typography.Text strong className="header">
                Documents
              </Typography.Text>
            </div>
            <div className="list">
              <SpaceWrapper>
                {listOfDocs.map((doc) => {
                  return (
                    <Tooltip
                      title={
                        doc?.index_status === indexStatuses.in_progress &&
                        "Document is being indexed."
                      }
                      key={doc?.document_id}
                    >
                      <Button
                        icon={
                          <IndexStatusIcon
                            status={docIndexStatus[doc?.document_id]}
                          />
                        }
                        type={
                          selectedDoc?.document_id === doc?.document_id
                            ? "primary"
                            : ""
                        }
                        block
                        className="item"
                        onClick={() => onSelectedDocChange(doc)}
                      >
                        {doc?.document_name}
                      </Button>
                    </Tooltip>
                  );
                })}
              </SpaceWrapper>
            </div>
          </Space>
          <Space
            direction="vertical"
            className="width-100 display-flex-align-center cur-pointer"
            onClick={() => setOpenManageDocs(true)}
          >
            <UploadIcon />
            <Typography.Text strong className={`${UPLOAD}`}>
              Upload a file
            </Typography.Text>
          </Space>
        </Space>
      </div>
      <ManageDocsModal
        open={openManageDocs}
        setOpen={setOpenManageDocs}
        handleDocAdd={handleDocAdd}
      />
    </>
  );
}

export { ListOfDocuments };
